import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    standalone: true,
    imports: [NgClass, TranslateModule],
})
export class BackButtonComponent {
  @Input() hasLinkStyle: boolean;
  @Output() goBack: EventEmitter<void>;

  constructor() {
    this.hasLinkStyle = false;
    this.goBack = new EventEmitter();
  }

  onGoBack(): void {
    this.goBack.emit();
  }
}
